import Vue from "vue";

import UserMessage from "./User-Message.vue";

export function load(store) {
    const selector = "user-message";

  // Is the custom Vue root element in the DOM?
  if (!document.querySelector(selector)) {
    return;
  }

  // Create a new Vue app with the imported Home component
  new Vue({
    store,
    render: createElement =>
      createElement(UserMessage, {
        props: {
          ...window[selector],
        },
      }),
  }).$mount(selector);
}
